import BecomingHostsStep from '@website/components/landingPage/hosts/becomingHost';
import HostJoinCallToAction from '@website/components/landingPage/hosts/callToAction';
import HostFAQs from '@website/components/landingPage/hosts/faqs';
import HeaderImage from '@website/components/landingPage/hosts/header';
import HostsStats from '@website/components/landingPage/hosts/stats';
import SeoMetaTags from '@website/components/seoMetaTags';
import BenefitsOfHosting from '@website/components/landingPage/hosts/hostingBenefits';
import { Container } from 'react-bootstrap';

export default function HostJoinPage() {
  return (
    <Container fluid>
      <SeoMetaTags
        description="Join Skyhook as a Host and list your trips on the Skyhook Platform"
        title="Become a Skyhook Host"
        showWebsiteName={false}
      />
      <HeaderImage />
      <HostsStats />
      <BenefitsOfHosting />
      <HostJoinCallToAction />
      <BecomingHostsStep />
      <HostFAQs />
      <HostJoinCallToAction />
    </Container>
  );
}

// HostJoinPage.Layout = ({ children }) => <>{children}</>;
